



















































































































































































































import store from './store'
import {
    //touchScreen,
    update
} from './mixins/mixins'
import {
    isTestMode,
    platform,
    linking
} from './mla-shared/';
import confirm from './components/Confirm.vue'
import { openLinkInBrowser } from './mla-shared';
const version = require('../package.json').version

export default {
    mixins: [update], // touchScreen

    data(this: any) {
        return {
            drawer: null,
            disable: false,
            //isTouchScreen: this.detect(),
            platform: platform(),
            version: version,
            testing: isTestMode(),
            offset: window.pageYOffset,
            breakpoint: this.$vuetify.breakpoint
        }
    },

    methods: {
        // Reset all data to defaults
        resetData: function (this: any) {
            store.dispatch('resetState')
            // window.localStorage.clear()
            this.$router.go(this.$route)
        },

        // Disable the reset
        resetDisable: function (this: any) {
            if (this.disable === true) {
                store.dispatch('resetDisable', true)
            }
        },
        etools() {
            openLinkInBrowser('https://etools.mla.com.au/');
        },
        eLearning: async function (this: any) {
            if (await this.$refs.confirm.open(
                'eLearning: Pasture Utilisation Course',
                'Learn how to identify any constraints in the utilisation of your pastures and put in place actions to enable you to lift stock numbers and better manage green pasture utilisation on grazed land.',
                {
                    color: 'blue',
                    width: 400,
                    cta: 'View Course'
                }
            )) {
                openLinkInBrowser('https://elearning.mla.com.au/courses/pasture-utilisation/');
            }
        },
        support() {
            linking({
                operation: 'openURL',
                openURL: 'mailto:tools@mla.com.au',
            });
        },
        survey() {
            openLinkInBrowser('https://forms.office.com/Pages/ResponsePage.aspx?id=HJuCo77s1EmI6U8o95r6Eb5jKcqch21Kp-7SYRq4csRUQUMyVEpQUExESjJYUlVSRFRaQzBZQURONy4u');
        }
    },

    mounted(this:any) {
        this.$root.$confirm = this.$refs.confirm
        window.onscroll = () => {
            (this as any).offset = window.pageYOffset;
        }
        // console.log(this.breakpoint)
    },

    destroyed() {
        window.onscroll = null;
    },

    components: { confirm },

    store
}
